import { IActiveReaction } from "@gtmhub/whiteboards/models";
import { Group } from "konva/lib/Core";
import { TopPadding } from ".";
import { ContainerType, newContainer, ContainerSize, newEmoji } from "./utils";

export const FIRST_ACTION_X_OFFSET = 6;
export const ACTION_Y_OFFSET = 5;
export const ACTION_X_OFFSET = 24;
const MAX_EMOJIS_PER_ROW = 8;
const EMOJI_HEIGHT = 16;

export class Actions {
  constructor(private actions: IActiveReaction[]) {}

  build(): Group {
    const actionsContainer = newContainer({ id: "actions-group", x: ContainerSize.WIDTH + 200, y: TopPadding.HEIGHT, name: "voting" }, ContainerType.Group) as Group;
    const actionsWrapper = newContainer({ id: "actions-wrapper", name: "voting" });
    actionsContainer.add(actionsWrapper);

    let posX = 0;
    let row = 1;
    this.actions.forEach((action, idx) => {
      if (idx + 1 > MAX_EMOJIS_PER_ROW * row) {
        row++;
        posX = 0;
        actionsWrapper.setAttr("height", actionsWrapper.height() + ACTION_Y_OFFSET + EMOJI_HEIGHT);
      }

      let offset = ACTION_X_OFFSET;
      if (idx % MAX_EMOJIS_PER_ROW === 0) {
        offset = FIRST_ACTION_X_OFFSET;
      }
      const emoji = newEmoji({
        id: action.name,
        text: action.emoji,
        position: { x: posX + offset, y: row * ACTION_Y_OFFSET + (row - 1) * EMOJI_HEIGHT },
      });

      //TODO: Next iteration - attach a single click handler on the container and then determine the clicked icon
      emoji.on("click", () => actionsContainer.fire("reaction-taken", { emoji }, true));

      if (row === 1) {
        actionsWrapper.setAttr("width", actionsWrapper.width() + ACTION_X_OFFSET);
      }
      actionsContainer.add(emoji);

      posX = posX + offset;
    });

    actionsWrapper.setAttr("width", actionsWrapper.width() - ACTION_X_OFFSET / 2);
    return actionsContainer;
  }
}
